import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { ICreateReasonBlock } from "./interfaces/create-reason-for-block.interface";
import { IUpdateReasonBlock } from "./interfaces/update-reason-for-block.interface";
import { ReasonVisitAttributes } from "@albatrosdeveloper/ave-models-package";
import { AbstractService } from "app/services/abstract.service";
import MotiveBlockAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/motive-block-business-partner/motive-block-business-partner.entity";
const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "motive_block";

@Injectable({
  providedIn: "root",
})
export class ReasonBlockService extends AbstractService<
  MotiveBlockAttributes, //aun toca chequear si es este o no
  ICreateReasonBlock,
  IUpdateReasonBlock
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<MotiveBlockAttributes>, 
    companyIds: number[]  // Add your companyIds if necessary,
    ,
    statusIds: number[]  // Add your statusIds if necessary,
  ): Observable<IPaginationResult<MotiveBlockAttributes>> {
  
    const query = buildQuery<MotiveBlockAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("id", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      companyIds && companyIds.length > 0 ? andAllWhere('company.id' as keyof MotiveBlockAttributes, Ops.in(...companyIds)) : noop(),
      statusIds && statusIds.length > 0 ? andAllWhere('statusId' as keyof MotiveBlockAttributes, Ops.in(...statusIds)) : noop(),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<MotiveBlockAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<MotiveBlockAttributes[]>> {
    const query = buildQuery<MotiveBlockAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["id", "name"]),
      orderBy("id", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<MotiveBlockAttributes[]>>(API_URL);
  }
}
